export default __webpack_public_path__ + "images/43da53199b8a847399ed0d29c549a850-no-results--dark.svg";